<!-- Search expanded Section start -->
<section class="w-100 d-flex align-items-center" role="search" style="position: relative;z-index: 10;">
    <div class="col-10 px-0">
        <!-- <div class="d-flex flex-wrap flex-md-nowrap w-100 ml-2"> -->
        <div id="elasticSearchBar" class="w-100 d-flex justify-content-between align-items-center search form-control px-1">
            <div class="col-auto p-0" *ngIf="showBack">
                <button
                    type="button"
                    (click)="backwardNavigation()"
                    [attr.aria-label]="'Go Back'"
                    class="btn btn-icon d-flex align-items-center tooltip bottom sm bottom-left position-relative ml-1 pl-2"
                    id="backtoprojBtn"
                    data-tooltip="Back">
                    <em
                        class="ic-flip custom-ic-flip align-text-top material-icons-outlined text-blue" 
                        aria-hidden="true">arrow_forward_ios
                    </em>
                </button>
            </div>
            <div class="col p-0">
                <!-- Search input box -->
                <label for="searchTaxonomies" class="sr-only">Search</label>
                <input
                    *ngIf="context_page === 'taxonomy_detail'
                        || context_page === 'project_detail'
                        || isAdvanceSearch"
                    type="search"
                    class="border-0 w-100"
                    aria-haspopup="false"
                    aria-autocomplete="both"
                    autocorrect="off"
                    autocapitalize="off"
                    aria-required="false"
                    placeholder="Search"
                    [(ngModel)]="searchKeyword"
                    id="searchTaxonomies"
                    (keyup.enter)="search(0)"
                    (focus)="onFocus($event)" 
                    autocomplete="off" />

                <input
                    *ngIf="(!context_page.includes('detail'))
                        && !isAdvanceSearch"
                    type="search"
                    class="border-0 w-100"
                    aria-haspopup="false"
                    aria-autocomplete="both"
                    autocorrect="off"
                    autocapitalize="off"
                    aria-required="false"
                    placeholder="Search"
                    [(ngModel)]="searchKeyword"
                    id="searchTaxonomies"
                    (keyup)="emitSearchText()"
                    (focus)="onFocus($event)" 
                    autocomplete="off" />
            </div>

            <div class="col-auto p-0 d-flex align-items-center justify-content-end">
                <!-- Clear or cancel option when any keyword is entered -->
                <button type="button" class="btn btn-clear btn-solid border-0 px-1 ps-0 d-flex align-items-center"
                    *ngIf="searchKeyword && searchKeyword.length" aria-label="Clear search" id="clearBtn"
                    (click)="clearSearchKeyword();">
                    <em class="material-icons-outlined button-icon font-4x" aria-hidden="true">
                        close
                    </em>
                </button>

                <!-- Advnace Search Button -->
                <button type="button" *ngIf="advanceSearchFilter" 
                    id="advance-search" data-toggle="dropdown"
                    class="btn btn-clear btn-solid border-0 px-1 ps-0 d-flex align-items-center"
                    [attr.aria-label]="'Advance Search Filters'" aria-haspopup="true"
                    (click)="showAdvanceSearch($event);"
                    [attr.aria-expanded]="enableAdvanceSearch && !isAdvanceSearch ? false : true">
                    <em class="material-icons-outlined button-icon font-4x" aria-hidden="true">
                        tune
                    </em>
                </button>
            </div>
        </div>
        <span class="sr-only" role="alert">{{textMessage}}</span>
        <!-- </div> -->
    </div>

    <div class="col-auto p-0" *ngIf="!checkResetButtonDisabled()">
        <button class="btn btn-clear text-underline btn-sm" (click)="resetFilters($event,'close');">
            Reset
        </button>
    </div>
</section>

<!-- Advance search dropdown filters -->
<ng-container *ngIf="filterDataLoaded && enableAdvanceSearch && isAdvanceSearch">
    <div class="dropdown mt-2 pl-2" id="div-search-panel">
        <div class="col-12 p-0 align-items-center d-flex flex-wrap" aria-labelledby="advance-search">
            <div class="col-auto p-0">
                <app-search-filter (checkboxSelectEvent)="onCheckboxSelectEvent($event)"
                    [dropdownObject]="dropdownObject" (filterObject)="collectFilterCriteria($event);"
                    class="d-flex w-100" #searchFilter>
                </app-search-filter>
            </div>
            <div class="col-auto p-0">
                <button type="button" id="add-more" (click)="addAdvanceSearch()" aria-haspopup="true"
                    data-toggle="dropdown" [attr.aria-expanded]="!advanceSearchToggle?false:true"
                    [ngStyle]="{'opacity':!advanceSearchToggle ? '1' : '0' }"
                    class="text-underline btn btn-clear btn-add-more font-2x position-relative">
                    Add more
                </button>
                <div aria-labelledby="add-more" [ngClass]="advanceSearchToggle ? 'add-more__position': ''"
                    [ngStyle]="{'opacity':advanceSearchToggle ? '1' : '0' }">
                    <app-advance-search id="ul-panel" [appendMargin]="appendMargin" [viewLocation]="viewLocation"
                        [taxonomyId]="taxonomyId" (clickOutside)="toggleAdvanceSearch($event,'close')" #advanceSearch
                        [uniqueId]="'name'" [listingObj]="advanceSearchList"
                        (advanceFilterObject)="collectAdvanceFilterCriteria($event);"
                        [advanceOptionalFilter]="advanceOptionalFilter">
                    </app-advance-search>
                </div>
            </div>
        </div>
    </div>
</ng-container>
<div class="col-12 pl-4 d-inline-flex align-items-center mt-1">
    <ng-container *ngFor="let key of Object.keys(advanceOptionalFilter)">
        <div class="auto-complete__choice-tag d-flex my-1 mr-2 p-1 align-items-center"
            *ngFor="let option of advanceOptionalFilter[key];let index=index;">
            <ng-container *ngIf="advanceOptionalFilter[key].length > 0">
                <span class="text-truncate d-inline-block tag font-1x" title="{{key}} : {{option.name ||option.label}}">
                    {{key | titlecase}} : {{option.name ||option.label}}
                </span>
                <button type="button" (click)="deleteObj(option,$event)" id="deleteSelectedElement"
                    class="auto-complete__choice-tag__remove btn-icon cursor-pointer font-2x"
                    attr.aria-label="remove {{key}} : {{option.name ||option.label}}">
                    <em class="material-icons-outlined button-icon font-2x" aria-hidden="true">
                        close
                    </em>
                </button>
            </ng-container>
        </div>
    </ng-container>
</div>
<app-preloader 
    *ngIf="searchTrigger"
    [loaderText]="'Loading Data...'"
    class="w-100 position-fixed preloader-backdrop">
</app-preloader>